import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  apiRequest,
  errorFormatHandler,
  isDevelop,
} from "../../helpers/apiHelper";

const apiEnv = isDevelop
  ? process.env.REACT_APP_TEST_API_URL
  : process.env.REACT_APP_PUBLIC_API_URL;

export const fetchSearchInvoice = createAsyncThunk(
  "/raports/cautaFacturaAwb",
  async (
    params: {
      factura: string | number | null;
    },
    { rejectWithValue, dispatch },
  ) => {
    try {
      const { data: responseData } = await apiRequest(
        "/cautaFacturaAwb",
        "POST",
        params,
      );
      return responseData;
    } catch (err: any) {
      console.warn("/raports/cautaFacturaAwb", err);
      return rejectWithValue(errorFormatHandler(err, dispatch));
    }
  },
);

export const fetchDownloadTemperatureRaport = createAsyncThunk(
  "/raports/fetchDownloadTemperatureRaport",
  async (
    {
      idRaport,
    }: {
      idRaport: string;
    },
    { rejectWithValue, dispatch },
  ) => {
    try {
      window
        .open(`${apiEnv}/downloadTemperatureRaport/${idRaport}`, "_blank")
        ?.focus();
    } catch (err: any) {
      console.warn("/raports/fetchDownloadTemperatureRaport", err);
      return rejectWithValue(errorFormatHandler(err, dispatch));
    }
  },
);

export const fetchDownloadCmr = createAsyncThunk(
  "/raports/fetchDownloadCmr",
  async (
    {
      idTransport,
    }: {
      idTransport?: number | string;
    },
    { rejectWithValue, dispatch },
  ) => {
    try {
      window.open(`${apiEnv}/descarcaCMR/${idTransport}`, "_blank")?.focus();
    } catch (err: any) {
      console.warn("/raports/fetchDownloadCmr", err);
      return rejectWithValue(errorFormatHandler(err, dispatch));
    }
  },
);

export const fetchCargoNode = createAsyncThunk(
  "/raports/fetchCargoNode",
  async (
    params: {
      page?: number;
      perPage?: number;
      idNod?: string | number | undefined;
    },
    { rejectWithValue, dispatch },
  ) => {
    try {
      const { data } = await apiRequest("/showCargoInNod", "GET", params);
      return data;
    } catch (err: any) {
      console.warn("/raports/fetchCargoNode", err);
      return rejectWithValue(errorFormatHandler(err, dispatch));
    }
  },
);

export const fetchCargoCar = createAsyncThunk(
  "/raports/fetchCargoCar",
  async (
    params: {
      page?: number;
      perPage?: number;
      idAuto?: string | number | undefined;
    },
    { rejectWithValue, dispatch },
  ) => {
    try {
      const { data } = await apiRequest("/showCargoInCar", "GET", params);
      return data;
    } catch (err: any) {
      console.warn("/raports/fetchCargoCar", err);
      return rejectWithValue(errorFormatHandler(err, dispatch));
    }
  },
);

export const fetchActiveCargoCars = createAsyncThunk(
  "/raports/fetchActiveCargoCars",
  async (
    params: {
      page?: number;
      perPage: number;
      nrauto?: string;
      marca?: string;
      model?: string;
    },
    { rejectWithValue },
  ) => {
    try {
      const { data } = await apiRequest(`/displayActiveCars`, "GET", params);
      return data;
    } catch (err: any) {
      console.warn("/raports/fetchActiveCargoCars", err);
      return rejectWithValue(errorFormatHandler(err));
    }
  },
);

export const fetchDownloadTemperatureChart = createAsyncThunk(
  "/raports/fetchDownloadTemperatureChart",
  async (
    {
      nrAuto,
      dataCursa,
    }: {
      nrAuto?: string | number | null;
      dataCursa?: string | Date | null;
    },
    { rejectWithValue, dispatch },
  ) => {
    try {
      window
        .open(
          `${apiEnv}/downloadAutoTemperatureRaport?nrAuto=${nrAuto}&dataCursa=${dataCursa}`,
          "_blank",
        )
        ?.focus();
    } catch (err: any) {
      console.warn("/raports/fetchDownloadTemperatureChart", err);
      return rejectWithValue(errorFormatHandler(err, dispatch));
    }
  },
);

export const postFinishDelivery = createAsyncThunk(
  "/raports/postFinishDelivery",
  async (
    params: {
      id_transport_marfa?: number;
      id_bin?: number;
      id_colet?: number;
      data_finalizarii?: string;
    },
    { rejectWithValue, dispatch },
  ) => {
    try {
      const { data } = await apiRequest("/closeDelivery", "POST", params);
      return data;
    } catch (err: any) {
      console.warn("/raports/postFinishDelivery", err);
      return rejectWithValue(errorFormatHandler(err, dispatch));
    }
  },
);

export const fetchUndeliveredPackagesCentralizer = createAsyncThunk(
  "/raports/fetchUndeliveredPackagesCentralizer",
  async (
    params: {
      page?: number;
      perPage?: number;
    },
    { rejectWithValue, dispatch },
  ) => {
    try {
      const { data } = await apiRequest(
        "/displayUndeliveredPackagesCentralizer",
        "GET",
        params,
      );
      return data;
    } catch (err: any) {
      console.warn("/raports/fetchUndeliveredPackagesCentralizer", err);
      return rejectWithValue(errorFormatHandler(err, dispatch));
    }
  },
);

export const fetchPackageHistory = createAsyncThunk(
  "/raports/fetchPackageHistory",
  async (
    params: {
      doc_trans: string | number | null;
    },
    { rejectWithValue, dispatch },
  ) => {
    try {
      const { data: responseData } = await apiRequest(
        "/getAwbHistoryData",
        "GET",
        params,
      );

      return responseData;
    } catch (err: any) {
      console.warn("/raports/fetchPackageHistory", err);
      return rejectWithValue(errorFormatHandler(err, dispatch));
    }
  },
);

export const fetchPackageHistoryWithActions = createAsyncThunk(
  "/raports/fetchPackageHistoryWithActions",
  async (
    params: {
      doc_trans: string | number | null;
    },
    { rejectWithValue, dispatch },
  ) => {
    try {
      const { data: responseData } = await apiRequest(
        "/getActionsAwbHistoryData",
        "GET",
        params,
      );

      return responseData;
    } catch (err: any) {
      console.warn("/raports/fetchPackageHistoryWithActions", err);
      return rejectWithValue(errorFormatHandler(err, dispatch));
    }
  },
);

export const fetchDownloadHistoryTemperatureRaport = createAsyncThunk(
  "/raports/downloadHistoryTemperatureRaport",
  async (
    {
      awb,
    }: {
      awb: string | number | null;
    },
    { rejectWithValue, dispatch },
  ) => {
    try {
      window
        .open(`${apiEnv}/downloadHistoryTemperatureRaport/${awb}`, "_blank")
        ?.focus();
    } catch (err: any) {
      console.warn("/raports/downloadHistoryTemperatureRaport", err);
      return rejectWithValue(errorFormatHandler(err, dispatch));
    }
  },
);

export const fetchTemperatureAlerts = createAsyncThunk(
  "/raports/fetchTemperatureAlerts",
  async (
    params: {
      page?: number;
      perPage?: number;
      status?: number;
    },
    { rejectWithValue, dispatch },
  ) => {
    try {
      const { data } = await apiRequest(
        "/showTemperatureAlerts",
        "GET",
        params,
      );
      return data;
    } catch (err: any) {
      console.warn("/raports/fetchTemperatureAlerts", err);
      return rejectWithValue(errorFormatHandler(err, dispatch));
    }
  },
);

export const postSolveTemperatureAlert = createAsyncThunk(
  "/raports/postSolveTemperatureAlert",
  async (
    params: {
      id_alerta: number;
      observatii: string | number | null;
    },
    { rejectWithValue, dispatch },
  ) => {
    try {
      const { data } = await apiRequest(
        `/solveTemperatureAlert`,
        "POST",
        params,
      );
      return data;
    } catch (err: any) {
      console.warn("/raports/postSolveTemperatureAlert", err);
      return rejectWithValue(errorFormatHandler(err, dispatch));
    }
  },
);
